<template>
  <div class="searchbar" :style="containerStyle">
    <div class="searchbar-content" :style="style">
      <img src="./images/search.png" class="icon" alt="">
      <span>{{ value.placeholder }}</span>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, InjectReactive } from 'vue-property-decorator';
import _ from 'lodash';
import Controller from 'beans-admin-plugin/components/page-creator/controller';
import { getStyle } from 'beans-admin-plugin/components/page-creator/helper';

@Component
export default class PageCreateSearchbar extends Vue {
  @Prop(Object) value;
  @InjectReactive() pageWidth;

  static defaultValue = {
    style: {
      backgroundColor: '#F2F2F2',
      fontSize: 14,
      height: 36,
      color: '#999999',
      borderRadius: 18,
      container: {
        backgroundColor: '#ffffff',
        paddingTop: 13,
        paddingBottom: 13,
        paddingLeft: 15,
        paddingRight: 15,
      }
    },
    placeholder: '搜索文章或专栏'
  }

  static Controller = {
    functional: true,
    render(h, context) {
      const { parent } = context;
      const configColumns = [
        {
          prop: 'placeholder',
          label: '输入框占位文本',
          renderCell: 'input'
        }
      ];
      const styleColumns = [
        {
          prop: 'backgroundColor',
          label: '输入框背景色',
          renderCell: {
            component: 'colorPicker',
            props: {
              'show-alpha': true
            }
          }
        },
        {
          prop: 'height',
          label: '输入框高度',
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'borderRadius',
          label: '输入框圆角',
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'fontSize',
          label: '占位文本字号',
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'color',
          label: '占位文本颜色',
          renderCell: {
            component: 'colorPicker',
            props: {
              'show-alpha': true
            }
          }
        },
        {
          prop: 'container.backgroundColor',
          label: '背景色',
          renderCell: {
            component: 'colorPicker',
            props: {
              'show-alpha': true
            }
          }
        },
        {
          prop: 'container.paddingTop',
          label: parent.$t('bean.pageGenerator.paddingTop'),
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'container.paddingBottom',
          label: parent.$t('bean.pageGenerator.paddingBottom'),
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'container.paddingLeft',
          label: parent.$t('bean.pageGenerator.paddingLeft'),
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        },
        {
          prop: 'container.paddingRight',
          label: parent.$t('bean.pageGenerator.paddingRight'),
          renderCell: {
            component: 'inputNumber',
            props: {
              min: 0
            }
          }
        }
      ];
      return (
        <Controller
          {...context.data}
          configColumns={configColumns}
          styleColumns={styleColumns}
          animation
        />
      );
    }
  }

  get style() {
    return getStyle(_.get(this, 'value.style') || {}, this.pageWidth);
  }

  get containerStyle() {
    return getStyle(_.get(this, 'value.style.container') || {}, this.pageWidth);
  }
}

</script>

<style scoped lang="scss">
  .searchbar-content {
    display: flex;
    align-items: center;

    .icon {
      width: 15px;
      height: 15px;
      margin: 0 16px;
    }
  }
</style>

